import { getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Assert } from '@/utils/validate'
import * as NumberUtils from '@/utils/NumberUtils'
import lang from '@/lang'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'

export const MONTH_RANGE = 12

/**
 * 获取汇率，如果指定日期没有汇率，那么就取指定日期上一个月的汇率
 * @param sourceCode 原币种
 * @param targetCode 目标币种
 * @param businessDate 汇率日期
 * @param lookup 循环查询次数 (默认:0)
 * @param warning 如果找不到汇率是否弹出警告框(默认：否)
 */
export function getForeignExchangeRateSafely(sourceCode, targetCode, businessDate, lookup = 0, warning = false) {
  // 判断日期是否为字符串（有时候后端返回前端是json数据,日期已经是字符串了,此时需要转换一下）
  if (typeof businessDate === 'string') {
    businessDate = new Date(businessDate.replace(/-/g, '/'))
  }
  // 如果指定日期走过12个月，那么汇率取当前月的
  if (businessDate && getBetweenMonths(businessDate, new Date()) > MONTH_RANGE) {
    businessDate = new Date()
  }
  const inputMonth = businessDate.getMonth() + 1
  const month = String(businessDate.getFullYear()) + (inputMonth >= 10 ? String(inputMonth) : '0' + String(inputMonth))
  const currentMonthRateArray = getFilterCacheList(basicCacheKeys.basic_data_FxBillingRate, (item) => {
    return item.month === month
  })
  let rate = NaN
  if (currentMonthRateArray && currentMonthRateArray.length > 0) {
    rate = getRateInMonth(sourceCode, targetCode, currentMonthRateArray)
  }
  // 获取汇率，如果指定日期没有汇率，那么就取指定日期上一个月的汇率
  if (isNaN(rate) && lookup < MONTH_RANGE && businessDate) {
    const lastMonth = getPreMonth(businessDate)
    rate = getForeignExchangeRateSafely(sourceCode, targetCode, lastMonth, ++lookup, warning)
  } else if (isNaN(rate) && lookup >= MONTH_RANGE && warning) {
    Assert.isTrue(false, lang.t('baseInfo.rateManagement.notFoundRate', [targetCode]))
  }
  return NumberUtils.roundHalfUp(rate, 8)
}

/**
 * 获取上一个月
 */
export function getPreMonth(date) {
  const year = date.getFullYear() // 获取年份
  const month = date.getMonth() // 获取月份
  let year2 = year
  let month2 = parseInt(month) - 1
  if (month2 === 0) {
    year2 = parseInt(year2) - 1
    month2 = 12
  }
  const days2 = new Date(year2, month2, 1)
  return days2
}

/**
 * 根据月份取汇率，如果连续最近6个月都没有，那么就去后台取。
 *
 * @param sourceCode
 * @param targetCode
 * @param date
 * @param callBack
 * @return
 *
 */
export async function getForeignExchangeRateByDate(sourceCode, targetCode, date, callBack = null, warning = false) {
  const rate = await getForeignExchangeRateSafely(sourceCode, targetCode, date, 0, warning)
  return rate
}

/**
 * 计算二个日期相差的天数
 */
export function getBetweenMonths(startDate, endDate) {
  return (endDate.getFullYear() - startDate.getFullYear()) * 12 + endDate.getMonth() - startDate.getMonth()
}

export function getRateInMonth(targetCode, sourceCode, rates) {
  if (targetCode === sourceCode) {
    return 1.0
  }

  for (let i = 0; i < rates.length; i++) {
    const rate = rates[i]
    if (rate.currency === sourceCode && rate.baseCurrency === targetCode) {
      return parseFloat(rate.rate)
    }
  }

  let targetRate = null
  let sourceRate = null

  for (let i = 0; i < rates.length; i++) {
    const rate = rates[i]
    if (rate.currency === sourceCode) {
      targetRate = rate
      if (rate.baseCurrency === targetCode) {
        return parseFloat(targetRate.rate)
      }
      break
    }
  }

  for (let i = 0; i < rates.length; i++) {
    const rate = rates[i]
    if (rate.currency === targetCode) {
      sourceRate = rate
      if (rate.baseCurrency === sourceCode) {
        return CurrencyUtil.roundHalfUpRateByCurrency(sourceCode, 1.0 / parseFloat(sourceRate.rate))
      }
      break
    }
  }

  if (targetRate == null) {
    return NaN
  }

  if (sourceRate == null) {
    return NaN
  }

  if (sourceRate.baseCurrency !== targetRate.baseCurrency) {
    return NaN
  }
  const derived = parseFloat(targetRate.rate) / parseFloat(sourceRate.rate)
  return CurrencyUtil.roundHalfUpRateByCurrency(sourceCode, derived)
}
